import { render, staticRenderFns } from "./StarsRating.vue?vue&type=template&id=7aae49f7&scoped=true"
import script from "./StarsRating.vue?vue&type=script&lang=js"
export * from "./StarsRating.vue?vue&type=script&lang=js"
import style0 from "./StarsRating.vue?vue&type=style&index=0&id=7aae49f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aae49f7",
  null
  
)

export default component.exports